var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import BS_Modal from 'bootstrap/js/dist/modal';
export class Modals extends Component {
    constructor(isDebugEnabled = false) {
        super('Modals', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.btn-show-modal').on('click', (event, button) => {
                event.preventDefault();
                Modals.open($(button.attr('href')));
            });
            this.success();
        });
    }
    static open(target) {
        Modals.closeAllModals();
        const name = target.attr('id').replace('#', '');
        target.find('.search-no-results, .search-not-in-result, .search-show-after').addClass('d-none');
        target.find('.search-results').addClass('d-none').find('tbody').empty();
        target.find('.search-query').val('');
        target.find('input:not(.keep-value), textarea:not(.keep-value)').val('');
        target.find('select').each((select) => {
            select.get(0).selectedIndex = 0;
        });
        Modals.modals[name] = new BS_Modal(target.get(0), { backdrop: 'static', keyboard: false });
        Modals.modals[name].show();
        setTimeout(() => {
            $('.search-query, .main-form-field').get(0).focus();
        }, 400);
    }
    static closeAllModals() {
        Object.entries(this.modals).forEach(([name, modal]) => {
            modal.hide();
        });
    }
}
Modals.modals = {};
